import { mapGetters } from "vuex";
import draggable from "vuedraggable";
const codeMixin = {
  /**
   * @currentIndex 当前模块下标
   * @currentInfo  当前模块信息
   */
  computed: {
    ...mapGetters([
      "chooseComponentId",
      "templateList",
      "currentIndex",
      "currentInfo"
    ]),
    reqData() {
      return this.$store.state.user;
    }
  },
  components: {
    draggable
  },
  data() {
    return {
      fileObj: {
        url: process.env.BASE_URL + "/system/uploadFile"
      },
      itemIndex: 0 //wxSchoolPageItemList的下标
    };
  },
  watch: {
    //信息变动时则触发更新
    currentInfo: {
      handler(val) {
        this.$store.dispatch("design/updateTemplate", {
          currentInfo: val,
          currentIndex: this.currentIndex
        });
      },
      deep: true
    }
  },
  methods: {
    datadragEndContent(evt) {
      evt.preventDefault();
    },
    //上传图片前校验
    beforeUpload(file) {
      this.loading = true;
      const isJPG = file.type.indexOf("image") > -1;
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isJPG) {
        this.$message.error("上传文件必须是图片哦!");
        this.loading = false;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10MB!");
        this.loading = false;
      }
      return isJPG && isLt2M;
    },
    //wxSchoolPageItemList里面的图片上传成功
    successListUpdate(res) {
      this.$set(
        this.currentInfo.wxSchoolPageItemList[this.itemIndex],
        "picture",
        res.data
      );
      this.$set(
        this.currentInfo.wxSchoolPageItemList[this.itemIndex],
        "isEmpty",
        -1
      );
      this.itemIndex = "";
    },
    //currentInfo里的图片上传成功
    successUpdate(res) {
      this.$set(this.currentInfo, "picture", res.data);
      this.$set(this.currentInfo, "isEmpty", -1);
    },
    //更新图片
    updateImg(index) {
      this.itemIndex = index;
    }
  }
};
export { codeMixin };



// WEBPACK FOOTER //
// ./src/components/designPage/minix.js